import { Card, Col, Row } from "react-bootstrap";
import {
  Box,
  ButtonReturn,
  CardFooterCustom,
  CardHeader,
  CardIcon,
  ContainerMain,
  CustomButtonActions,
  CustomTable,
  NoFoundData,
  Title,
} from "../../styles";
import { MdCleaningServices, MdHistory, MdVisibility } from "react-icons/md";
import Loading from "../../../../Components/Loading";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getFlowHistoryList } from "../../../../services/flow-history";
import {
  ActionsType,
  FlowHistoryData,
  FlowHistoryResponse,
} from "../../../../@types/flow-history";
import Paginate from "../../../../Components/Paginate";
import dateFormat from "../../../../utils/dateFormat";
import {
  BoxSearchFilter,
  ButtonClearSearch,
  ButtonSearch,
  FormFilter,
  IconSearch,
  InputDateFinal,
  InputDateInicial,
  InputSearch,
  OptionFilter,
  SelectFilter,
  UntilText,
} from "./styles";
import HistoryModal from "./history-modal";
import { useGetProfileType } from "../../../../hooks/useGetProfileType";
import { renderValueText } from "../../../../utils/renderValueText";

export const returnLabel: Record<ActionsType, unknown> = {
  criacao: "Criação",
  atualizacao: "Atualização",
  remocao: "Remoção",
  desativacao: "Desativação",
};

const FlowHistory = () => {
  const verifyProfileAllowed = useGetProfileType();
  const today = new Date().toISOString();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<string>("");
  const [isSearch, setIsSearch] = useState(false);
  const [filter, setFilter] = useState<string>("select");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(true);
  const [historyList, setHistoryList] = useState<FlowHistoryResponse>();
  const [page, setPage] = useState<number>(1);
  const [historySelected, setHistorySelected] =
    useState<FlowHistoryData | null>(null);
  const { flow_slug } = useParams<{ flow_slug: string }>();

  const formatDate = (payload: string) => {
    const y = payload.split("-")[0];
    const m = payload.split("-")[1];
    const d = payload.split("-")[2].split("T")[0];

    return `${y}-${m}-${d}`;
  };

  const handleResetInputSearch = () => {
    setFilter("select");
    setSearchData("");
    setDataInicial(formatDate(today));
    setDataFinal(formatDate(today));
    setIsSearch(false);
  };

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    let value = e.target.value;
    if (filter === "user" && value.length) {
      setSearchData(value);
    } else {
      setSearchData(value.replace(/\D/g, ""));
    }
  };

  const handleChangeDataInicial = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    let value = e.target.value;
    setDataInicial(value);
  };

  const handleChangeDataFinal = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    let value = e.target.value;
    setDataFinal(value);
  };

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const getHistory = async ({ page }: { page: number }) => {
    try {
      let params = {
        page,
        flow: flow_slug,
      };

      if (filter?.length && searchData?.length) {
        if (filter === "user") {
          params["actor_name"] = searchData;
        }
      }

      if (filter === "data" && dataInicial && dataFinal) {
        params["created_at_before"] = dataInicial;
        params["created_at_after"] = dataFinal;
      }

      const { data } = await getFlowHistoryList(params);

      setHistoryList(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (flow_slug) {
      getHistory({ page });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flow_slug]);

  useEffect(() => {
    if (flow_slug) {
      getHistory({ page });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flow_slug, isSearch, page]);

  if (verifyProfileAllowed) {
    return (
      <ContainerMain>
        <h6>Você não tem permissão para acessar essa página!</h6>
      </ContainerMain>
    );
  }

  return (
    <ContainerMain>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Box>
                <CardIcon>
                  <MdHistory size={20} />
                </CardIcon>
                <Title>Histórico</Title>
              </Box>
              <FormFilter>
                <SelectFilter
                  onChange={(event) => setFilter(event.target.value)}
                >
                  <OptionFilter value="select" selected={filter === "selected"}>
                    Filtrar por
                  </OptionFilter>
                  <OptionFilter value="user" selected={filter === "user"}>
                    Usuário
                  </OptionFilter>
                  <OptionFilter value="data" selected={filter === "data"}>
                    Período
                  </OptionFilter>
                </SelectFilter>
                <BoxSearchFilter>
                  {filter === "data" ? (
                    <>
                      <InputDateInicial
                        style={{ width: "auto" }}
                        type={"date"}
                        placeholder="Data inicial"
                        value={dataInicial}
                        disabled={false}
                        onChange={handleChangeDataInicial}
                      />
                      <UntilText>Até</UntilText>
                      <InputDateFinal
                        style={{ width: "auto" }}
                        type={"date"}
                        placeholder="Data final"
                        value={dataFinal}
                        disabled={false}
                        onChange={handleChangeDataFinal}
                      />
                    </>
                  ) : (
                    <>
                      <IconSearch />
                      <InputSearch
                        style={{ width: "auto" }}
                        type={"text"}
                        placeholder="Digite sua busca"
                        value={searchData}
                        disabled={filter === "select"}
                        onChange={handleChangeSearch}
                      />
                    </>
                  )}
                </BoxSearchFilter>
                {!isSearch ? (
                  <ButtonSearch
                    disabled={false}
                    onClick={() => {
                      setIsSearch(true);
                    }}
                  >
                    {" "}
                    Buscar
                  </ButtonSearch>
                ) : (
                  <ButtonClearSearch
                    className="text-light"
                    variant="info"
                    onClick={handleResetInputSearch}
                  >
                    <MdCleaningServices size={15} /> Limpar
                  </ButtonClearSearch>
                )}
              </FormFilter>
            </CardHeader>
            <Card.Body>
              {loading ? (
                <div className="d-flex mt-4 justify-content-center">
                  <Loading />
                </div>
              ) : (
                <>
                  {historyList && historyList?.results?.length > 0 ? (
                    <CustomTable responsive="md">
                      <thead className="table-header">
                        <tr>
                          <th>Ações</th>
                          <th>Usuário</th>
                          <th>Criado em</th>
                          <th style={{ textAlign: "center" }}>Alterações</th>
                        </tr>
                      </thead>
                      <tbody className="table-body">
                        {historyList.results.map((item) => (
                          <tr key={`${item.object_id}-key`}>
                            <td>
                              {renderValueText(
                                returnLabel[item.action],
                                item.action
                              )}
                            </td>
                            <td>
                              {renderValueText(
                                item?.actor?.first_name,
                                "Sem informação."
                              )}
                            </td>
                            <td>
                              {renderValueText(
                                dateFormat(item.created_at, true),
                                "Sem informação."
                              )}
                            </td>
                            <td align="center">
                              <CustomButtonActions
                                variant="outline-secondary"
                                onClick={() => {
                                  setHistorySelected(item);
                                  handleOpenModal();
                                }}
                              >
                                <MdVisibility size={20} className="icon" />
                              </CustomButtonActions>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </CustomTable>
                  ) : (
                    <NoFoundData>Sem resultados!</NoFoundData>
                  )}
                </>
              )}
            </Card.Body>
            {historyList?.results?.length > 0 ? (
              <CardFooterCustom>
                <ButtonReturn onClick={() => history.push("/fluxo")}>
                  Voltar
                </ButtonReturn>
                <Paginate
                  flowData={historyList}
                  setPage={({ page }) => setPage(page)}
                  page={historyList?.current}
                />
              </CardFooterCustom>
            ) : (
              <CardFooterCustom>
                <ButtonReturn onClick={() => history.push("/fluxo")}>
                  Voltar
                </ButtonReturn>
              </CardFooterCustom>
            )}
          </Card>
        </Col>
      </Row>
      {isOpenModal && historySelected && (
        <HistoryModal
          item={historySelected}
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        />
      )}
    </ContainerMain>
  );
};

export default FlowHistory;
